import Phaser from "phaser";
export class firetail extends Phaser.GameObjects.Sprite {
    /**  
     * Firetail constructor : @param {object} scene - The scene this firetail belongs to @param {number} x - The x coordinate of the firetail  @param {number} y - The y coordinate of the firetail * @param {string} effectkey - The key of the effect 
     *  create function:  it is create emitter that responsible to make animation of fire tail its take @param {number} alpth -that detect transparency of firetail-  @param {number} scale -detect scale of the firetail- @param {number} speed -detect speed of emitting firetail from spaceship- @param {number} accelerationY -detect acceleration in Y axis- @param {number} angle - detect angle of firetail- @param {number} rotate -detect rotation of firetail- @param {number} lifespan -detect period of time that emitter be in the screen- @param {String} blendMode -detect mode of animation- @param {number} frequency -detect num of assets that render on screen -@param {number} x -this x axis of firetail - @param {number} y -this is y axis of firetail-*
     *  firetailAssets function :load assets on screen @param {Object} scene - The scene this firetail belongs to-
     *  firetailDestroy function : destroy firetail 
     *  firetailPause function : hide animation of firetail
     *  firetailResume function : Unhide animation of firetail
     *  Update Function :update position of firetail depend on position of spaceship 
     **/
    constructor(scene, x, y, effectkey) {
        super(scene, x, y, effectkey);
        this.scene = scene;
        this.x = x
        this.y = y
        this.effectkey = effectkey

    }
    create(scene) {
        this.particles = scene.add.particles(this.effectkey);

        this.emmiter = this.particles.createEmitter({
            alpha: { start: 1, end: 0 },
            scale: { start: 0.1, end: 0.6 },
            speed: 100,
            accelerationY: 500,
            angle: { min: 85, max: 95 },
            rotate: { min: 140, max: -140 },
            lifespan: { min: 100, max: 100 },
            blendMode: 'ADD',
            frequency: 150,
            x: this.x,
            y: this.y
        });
    }
    static firetailAssets(scene, key, path) {
        scene.load.image(key, path);
    }
    firetailDestroy() {
        this.particles.destroy();
    }

    firetailPause() {
        this.emmiter.setVisible(false)
    }
    firetailResume() {
        this.emmiter.setVisible(true)
    }
    update(x, y) {
        this.emmiter.setPosition(x, y)
    }
}